const GOOGLE_TEST_KEY = 'AIzaSyCTqN5UrrqK-aaJw5MeqoW2JRWh4RHMBRU';
const GOOGLE_PROD_KEY = 'AIzaSyA7qghFGBNo-DxGTTWoY0WDd4Ho7v5rdmo';
const GOOGLE_PROD_STATIC_MAP_API_KEY =
  'AIzaSyACis1Gu7CIYhDa_zJ3VhTMe14PLUVUqP0';

export const GOOGLE_GEOCODE_API_KEY = 'AIzaSyCdiMZCydxypfLZ58w1_1pvcHxW5K_WUtE';

export const GOOGLE_STATIC_API_KEY = window.location.origin.includes(
  'localhost'
)
  ? GOOGLE_TEST_KEY
  : GOOGLE_PROD_STATIC_MAP_API_KEY;

export const GOOGLE_API_KEY =
  window.location.origin.includes('localhost') ||
  window.location.origin.includes('bs-local')
    ? GOOGLE_TEST_KEY
    : GOOGLE_PROD_KEY;

export const TRIPPLANNER_MAP_ID = '392caa6a8fe9926e';
